class BruComfortLevel extends HTMLElement {
  connectedCallback() {
    this.selectedLabel = this.querySelector('[data-comfort-selected-label]');
    this.description = this.querySelector('[data-comfort-description]');
    this.inputs = this.querySelectorAll('input[type="radio"]');
    this.drawer = this.querySelector('[data-comfort-guide]');
    this.openButton = this.querySelector('[data-comfort-guide-open]');
    this.closeButtons = this.querySelectorAll('[data-comfort-guide-close]');

    this.inputs.forEach((input) => {
      input.addEventListener('change', () => this.updateDisplay(input));
    });

    if (this.openButton && this.drawer) {
      this.openButton.addEventListener('click', () => this.openDrawer());
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', () => this.closeDrawer());
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeDrawer();
      });
    }

    const checked = this.querySelector('input[type="radio"]:checked');
    if (checked) this.updateDisplay(checked);
  }

  openDrawer() {
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.openButton.setAttribute('aria-expanded', 'true');
    this.drawer.querySelector('[data-comfort-guide-close]')?.focus();
  }

  closeDrawer() {
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.openButton.setAttribute('aria-expanded', 'false');
    this.openButton.focus();
  }

  updateDisplay(input) {
    const label = input.dataset.label || '';
    const description = input.dataset.description || '';
    const selectedValue = Number(input.value);

    if (this.selectedLabel) {
      this.selectedLabel.textContent = `${input.value} - ${label}`;
    }

    if (this.description) {
      this.description.textContent = description;
    }

    this.style.setProperty('--comfort-level', input.value);
    this.style.setProperty('--comfort-progress', `${((selectedValue * 100) - 50) / 10}%`);

    this.querySelectorAll('.moores-comfort__level').forEach((level) => {
      const levelInput = level.querySelector('input[type="radio"]');
      const levelValue = Number(levelInput?.value || level.textContent.trim());

      level.classList.toggle('is-completed', levelValue < selectedValue);
      level.classList.toggle('is-current', levelValue === selectedValue);
      level.classList.toggle('is-unfilled', levelValue > selectedValue);
    });
  }
}

if (!customElements.get('moores-comfort-level')) {
  customElements.define('moores-comfort-level', BruComfortLevel);
}
